module.exports = __webpack_public_path__ + "img/gb6170.prt.8563537b.jpg";